export default {
      id: "menu-close-usage",
      viewBox: "0 0 18 12",
      url: __webpack_public_path__ + "img/icons.95404f0a.svg#menu-close",
      toString: function () {
        return this.url;
      }
    }